import React from 'react'

import { connect } from "react-redux"

import { Link } from 'react-router-dom' // When clicking a <Link>, the URL will be updated and the rendered content will change without reloading the page.

import { Form } from 'react-form'

import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { Card } from 'primereact/card'

import FieldInputText from '../components/common/FieldInputText'
import FieldPassword from '../components/common/FieldPassword'

import * as appActionCreators from "../actionCreators/app"
import * as authActionCreators from "../actionCreators/auth"

import '../css/login.css'

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      accountLoginDetails: {
        Username: '',
        Password: ''
      }
    }
  }

  componentDidMount() {
    // clear session timeout flag in case redirected here after timeout
    // that way we don't keep getting redirected
    this.props.clearSessionTimeOut()
  }

  performLogin = accountLoginDetails => {
    this.props.setLoading(true)
      .then(() => this.props.performLogin(accountLoginDetails))
      .then(response => {
        if (response && response.data && response.data.access_token) {
          this.props.clearAjaxResponse()
          this.props.history.push('/lobbyist/' + this.props.auth.lobbyistId)
        } else {
          let response = {
            data: {
              Success: false,
              ErrorMessages: {
                $values: ['Invalid login details.']
              }
            }
          }
          this.props.setAjaxResponse(response)
        }

        this.props.setLoading(false)
      })
      .catch((error) => {
        this.props.handleError(error)
          .then(() => this.props.setLoading(false))
      })
  }

  render() {
    return (
      <Form values={this.state.accountLoginDetails} onSubmit={this.performLogin}>
        {formApi => {
          return (
            <Card title="Login" className="login-card">
              <div className="p-grid">
                <div className="p-col-12 ui-md-12 ui-lg-12">
                  <FieldInputText field={"Username"} label={"Email"} />
                </div>
                <div className="p-col-12 ui-md-12 ui-lg-12">
                  <FieldPassword field={"Password"} label={"Password"} feedback={false} />
                </div>
                <div className="p-col-12 ui-md-12 ui-lg-12">
                  <Link to='/forgot-password'>
                    <div>Forgot My Password</div>
                  </Link>
                </div>
              </div>
              <Toolbar>
                <div className="p-toolbar-group-left">
                  {/* submits react-form's Form which performs validation and triggers submit evert if successful */}
                  <Button label="Login" onClick={formApi.submitForm} />
                </div>
              </Toolbar>
            </Card>
          )
        }}
      </Form>
    )
  }
}

const mapStateToProps = (state) => {
  const { auth } = state
  return { auth }
}

// this is how to combine actions available
const actionCreators = {
  ...authActionCreators,
  ...appActionCreators
}

export default connect(mapStateToProps, actionCreators)(Login);


// WEBPACK FOOTER //
// ./src/container/Login.js